<script>
import { mapState } from 'vuex'
import { Input } from '@/components/formelements'
import Validation from '@/plugins/validation'

export default {
  name: 'Login',
  data() {
    return {
      ...Validation,
    }
  },
  computed: {
    ...mapState ({
      failedLogin: state => state.user.failedLogin
    })
  },
  components: {
    Input
  },
  methods: {
    login(){
      if(this.$refs.loginForm.validate()) {
        this.$store.dispatch('user/USER_LOGIN')
      }
    }
  },
}
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12" >
        <v-form ref="loginForm" @keyup.native.enter="login">
          <Input form="user" field="username" :maxlength="128" :rules="[...required]" placeholder="" label="Username" />
          <Input form="user" field="password" :maxlength="128" :rules="[...required]" placeholder="" label="Password" type="password" />
          <p v-if="failedLogin" class="font-weight-black red--text">Login failed</p>
          <v-btn depressed color="accent" @click="login">Login<v-icon right>mdi-login</v-icon> </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
